import { render, staticRenderFns } from "./Careforsociety.vue?vue&type=template&id=7a23ff42&scoped=true&"
import script from "./Careforsociety.vue?vue&type=script&lang=js&"
export * from "./Careforsociety.vue?vue&type=script&lang=js&"
import style0 from "./Careforsociety.vue?vue&type=style&index=0&id=7a23ff42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23ff42",
  null
  
)

export default component.exports